import React from 'react';
import { GrapeSodaXdCard } from '../../product-cards/gummies/limited-distribution/grape-soda-card-xd';
import { CottonCandyXdCard } from '../../product-cards/gummies/limited-distribution/cotton-candy-card-xd';


export const D9XdRow = () => {
	return (
		<React.Fragment>
            <GrapeSodaXdCard />
            <CottonCandyXdCard />
          
		</React.Fragment>
	);
};
